import React, { type Dispatch } from 'react';
import { Dimensions } from 'react-native';

const window = Dimensions.get('window');
const screen = Dimensions.get('screen');

const ScreenSizeContext = React.createContext({ window, screen });
const setScreenSizeContext = React.createContext<
  Dispatch<React.SetStateAction<{ window: any; screen: any }>>
>(() => {});

const ScreenSizeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [dimensions, setDimensions] = React.useState({ window, screen });

  React.useEffect(() => {
    const subscription = Dimensions.addEventListener(
      'change',
      ({ window, screen }) => {
        setDimensions({ window, screen });
      }
    );
    return () => {
      subscription?.remove();
    };
  }, []);

  return (
    <ScreenSizeContext.Provider value={dimensions}>
      {/* <setScreenSizeContext.Provider value={setDimensions}> */}
      {children}
      {/* </setScreenSizeContext.Provider> */}
    </ScreenSizeContext.Provider>
  );
};

export default ScreenSizeProvider;
export { ScreenSizeContext, setScreenSizeContext };
